function ErrorComponent() {
  return <div>Unable to load payouts</div>;
}

export default ErrorComponent;
